<template>
  <div>
    <div>
      <img src="~@/assets/show/zhnj.jpg" />
    </div>
    <div class="box_content">
      <span class="box_span">文登区</span>
      <ul v-for="(item, index) of OrgTreeData" :key="index">
        <li class="li_bar" :class="{lifirst: item.name==='泽库镇'}" @click="dothing(item.id)">
          <router-link target="_blank" :to="{name: 'MachineMap', params: {orgId: childOrgId} }" style="color:#000;font-size:20px;">
            {{ item.name }}
          </router-link>
        </li>
      </ul>
      <div style="clear:both"></div>
      <!-- <div v-for="(item, index) in OrgTreeData" :key="index">
        <div class="OrgTreeView" @click="dothing(item.id)"><router-link :to="{name: 'MachineMap', params: {orgId: childOrgId} }"><span style="color:#fff;">{{ item.name }}</span></router-link></div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { SysOrgGetChild } from '@/api/main/SysOrgcountyManager'
export default {
  data() {
    return {
      orgId: '',
      childOrgId: '371081404000',
      OrgTreeData: []
    }
  },
  created() {
    this.orgId = this.$route.query.orgId
    this.SysOrgTree()
  },
  methods: {
    SysOrgTree() {
      SysOrgGetChild({ orgId: this.orgId }).then(res => {
        this.OrgTreeData = res.data
      })
    },
    dothing(val) {
      this.childOrgId = val
    }
  }
}
</script>
<style lang="less" scoped>
.box_content{
  width: 100%;
  min-height: 400px;
  text-align:center;
  padding:35px 0 60px 0;
}
.box_span {
  font-size: 22px;
  margin-bottom: 35px;
  font-weight: bold;
}
.box_span:hover{
  color: green;
}
li {
    display: inline-block;
    padding-left: 20px;
    margin: 20px 0 0px 0;
    font-size: 16px;
    height: 38px;
    line-height: 38px;
    background: url('~@/assets/icon/dot.png') 3px 16px no-repeat;
    a {
      color: #000;
      &:hover {
        color: #207e63;
      }
    }
  }
  .lifirst{
    margin-top: 34px;
  }
  .li_bar {
  width:20%;
  float: left;
  text-align: left;
  padding-left: 20px;
  height: 38px;
  line-height: 38px;
}
</style>
